var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('div',{staticClass:"header"},[_c('span',{on:{"click":function($event){return _vm.$router.back(-1)}}},[_c('i',{staticClass:"cubeic-back"})]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.videoInfo.title))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }